import { render, staticRenderFns } from "./ForgeFileViewer.vue?vue&type=template&id=2555d731&scoped=true"
import script from "./ForgeFileViewer.vue?vue&type=script&lang=js"
export * from "./ForgeFileViewer.vue?vue&type=script&lang=js"
import style0 from "./ForgeFileViewer.vue?vue&type=style&index=0&id=2555d731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555d731",
  null
  
)

export default component.exports